import { LIMITS } from './types';

/**
 * Truncates to at most `max` UTF-16 code units without splitting a surrogate
 * pair. Lengths are measured in code units everywhere (matching zod's `.max`).
 */
export function clampLength(value: string, max: number): string {
  if (value.length <= max) return value;
  let end = max;
  const last = value.charCodeAt(end - 1);
  if (last >= 0xd800 && last <= 0xdbff) end -= 1;
  return value.slice(0, end);
}

/** Trims and clamps a name; `null` if nothing is left. */
export function normalizeName(value: string): string | null {
  const trimmed = clampLength(value.trim(), LIMITS.name).trim();
  return trimmed === '' ? null : trimmed;
}

export function normalizeTitle(value: string): string {
  return clampLength(value, LIMITS.title);
}

/** Trims and clamps a comment; `undefined` when empty (no comment). */
export function normalizeComment(value: string): string | undefined {
  const trimmed = clampLength(value.trim(), LIMITS.comment).trimEnd();
  return trimmed === '' ? undefined : trimmed;
}

/** Accepts `#RGB` / `#RRGGBB` (any case, surrounding whitespace) → `#RRGGBB`, else `null`. */
export function normalizeColor(value: string): string | null {
  const match = /^#?([0-9a-f]{3}|[0-9a-f]{6})$/i.exec(value.trim());
  const hex = match?.[1];
  if (hex === undefined) return null;
  const full = hex.length === 3 ? hex.replace(/./g, '$&$&') : hex;
  return `#${full.toUpperCase()}`;
}
